import { IHttpResponse, IProviderEntity } from '@shared/models';
import useAxios, { UseAxiosResult } from 'axios-hooks';

export default function useProviders(): UseAxiosResult<IHttpResponse<IProviderEntity[]>> {
  return useAxios<IHttpResponse<IProviderEntity[]>>({
    url: 'providers',
    method: 'GET'
  });
}
